import { btnDelay } from "common/utils";
/**
 * Step 1: アイコン選択方法ステップ
 */
import I18n from "features/shared/i18n";
import {
  EditorState,
  EditorStep,
  IconMethod,
} from "../types";

interface IconMethodStepProps {
  state: EditorState;
  updateState: (updates: Partial<EditorState>) => void;
  goToStep: (step: EditorStep) => void;
}

export const IconMethodStep = ({ updateState, goToStep }: IconMethodStepProps) => {
  const handleSelectPreset = () => {
    btnDelay(() => {
      updateState({ iconMethod: IconMethod.PRESET });
      goToStep(EditorStep.PRESET_ICON);
    });
  };

  const handleSelectUpload = () => {
    btnDelay(() => {
      updateState({ iconMethod: IconMethod.UPLOAD, icon: "" });
      goToStep(EditorStep.UPLOAD_ICON);
    });
  };

  const handleSelectProfileAI = () => {
    btnDelay(() => {
      updateState({ iconMethod: IconMethod.PROFILE_AI });
      goToStep(EditorStep.PROFILE_AI);
    });
  };

  return (
    <div className="flex-col-el flex-center w-full h-full">
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[32px]">
          {I18n.t("MSG_ICON_SELECT_TITLE_BY_PARENT")}
        </p>
      </div>

      <div className="flex-row-el flex-center gap-4">
        <div
          onClick={handleSelectPreset}
          className="flex-col-el items-center justify-center w-[220px] h-[220px] rounded-[4px] bg-orange-100 cursor-pointer select-none"
        >
          <span className="material-symbols-outlined !text-5xl text-white mb-3">grid_view</span>
          <p className="text-body text-[22px] text-white text-center whitespace-pre-line">
            {I18n.t("MSG_ICON_SELECT_SYSTEM_BY_PARENT")}
          </p>
        </div>

        <div
          onClick={handleSelectUpload}
          className="flex-col-el items-center justify-center w-[220px] h-[220px] rounded-[4px] bg-green-100 cursor-pointer select-none"
        >
          <span className="material-symbols-outlined !text-5xl text-white mb-3">upload</span>
          <p className="text-body text-[22px] text-white text-center whitespace-pre-line">
            {I18n.t("MSG_ICON_SELECT_UPLOAD_BY_PARENT")}
          </p>
        </div>

        <div
          onClick={handleSelectProfileAI}
          className="flex-col-el items-center justify-center w-[220px] h-[220px] rounded-[4px] bg-blue-100 cursor-pointer select-none"
        >
          <span className="material-symbols-outlined !text-5xl text-white mb-3 mt-8">
            auto_awesome
          </span>
          <p className="text-body text-[22px] text-white text-center whitespace-pre-line">
            {I18n.t("MSG_ICON_SELECT_PROFILE_AI_BY_PARENT")}
          </p>
        </div>
      </div>
    </div>
  );
};
